import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/tables/Icon';
import { getGameType, setPlayUrlPrefix } from '../../variables/gameTypes';

// Sets tab: every Set (a named, shareable bundle of games) as a card grid.
export default function SetsTab({ search, refresh, onEdit }) {
   const navigate = useNavigate();
   const [sets, setSets] = useState([]);
   const [members, setMembers] = useState([]);
   const [localRefresh, setLocalRefresh] = useState(0);

   useEffect(() => {
      axios.get('/api/set', { withCredentials: true })
         .then(response => setSets(response.data || []))
         .catch(err => { if(err.response && err.response.status === 401) navigate('/login'); });
      axios.get('/api/setcard', { withCredentials: true })
         .then(response => setMembers(response.data || []))
         .catch(() => {});
   }, [refresh, localRefresh, navigate]);

   const bump = () => setLocalRefresh(prev => prev + 1);

   const membersBySet = useMemo(() => {
      const grouped = {};
      members.forEach(elem => {
         if(!elem.set || !elem.set.id || !elem.grid) return;
         const list = grouped[elem.set.id] || (grouped[elem.set.id] = []);
         list.push(elem.grid);
      });
      return grouped;
   }, [members]);

   const visibleSets = useMemo(() => {
      const query = (search || '').trim().toLowerCase();
      return sets
         .filter(s => !query || (s.name || '').toLowerCase().includes(query))
         .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
   }, [sets, search]);

   if(visibleSets.length === 0) {
      return <div className="games-empty">Наборів не знайдено</div>;
   }

   return (
      <div className="games-grid">
         {visibleSets.map(set => {
            const setMembers = membersBySet[set.id] || [];
            const distinctTypes = [...new Set(setMembers.map(g => g.type))];
            const clearurl = setPlayUrlPrefix();
            return (
               <div key={set.id} className="game-card set-card">
                  <div className="game-card-body" onClick={() => navigate('/games/sets/' + set.id)}>
                     <div className="set-card-type-dots">
                        {distinctTypes.length === 0
                           ? <span className="set-card-empty-dot" />
                           : distinctTypes.map(t => (
                              <span key={t} className="set-card-type-dot" style={{ background: getGameType(t).accent }} title={getGameType(t).label} />
                           ))}
                     </div>
                     <div className="game-card-name">{set.name}</div>
                     <div className="game-card-count">{setMembers.length} ігор</div>
                  </div>
                  <div className="game-card-actions" onClick={e => e.stopPropagation()}>
                     <Icon mode="edit" id={set.id}
                        stateHundler={(state, id) => { if(state === 'edit') onEdit(id); }}
                        className="icon-edit" classes="icon-dimensions-mid" />
                     <Icon mode="copy-url" clearurl={clearurl} item={set} headers={{ urlfield: 'id' }}
                        className="icon-copyurl" classes="icon-dimensions-mid" />
                     <Icon mode="copy-iframe" clearurl={clearurl} item={set}
                        className="icon-copyframe" classes="icon-dimensions-mid" />
                     <Icon mode="delete" url={'/api/set/' + set.id} onRefreshHundler={bump}
                        className="icon-delete" classes="icon-dimensions-mid" />
                  </div>
               </div>
            );
         })}
      </div>
   );
}
